import { useEffect, useCallback, useRef } from "react";

export default function useClampedScroll(imageHeight) {
  const ref = useRef(null);

  const handleScroll = useCallback(() => {
    if (!ref.current) return;
    const viewportHeight = window.innerHeight;
    const maxScroll = Math.max(imageHeight - viewportHeight, 0);
    const clamped = Math.min(window.scrollY, maxScroll);
    ref.current.style.transform = `translateY(${-clamped}px)`;
  }, [imageHeight]);

  useEffect(() => {
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, [handleScroll]);

  return { ref };
}
